const { v4: uuidv4 } = require('uuid');
const {
  WIDGET_TYPE,
  DEFAULT_DIMENSIONS,
  DEFAULT_PIVOT_TABLE_COLUMNS,
  DEFAULT_ATTRIBUTION_WINDOWS,
} = require('./constants');
const constants = require('./constants');

/**
 * @typedef {import("../types").DashboardWidget} DashboardWidget
 * @typedef {import("../types").DashboardWidgetTypeEnum} DashboardWidgetTypeEnum
 * @typedef {import("../types").DashboardWidgetSubTypeEnum} DashboardWidgetSubTypeEnum
 */

/**
 * @param {DashboardWidgetSubTypeEnum} tableType
 * @return {Array<string>} columns
 */
function getDefaultColumns(tableType) {
  return constants[`DEFAULT_${tableType.toUpperCase()}_COLUMNS`] || DEFAULT_PIVOT_TABLE_COLUMNS;
}

/**
 * @param {object} obj
 * @param {string} obj.id uuid
 * @param {DashboardWidgetTypeEnum} obj.type
 * @param {DashboardWidgetSubTypeEnum} [obj.subType]
 * @return {DashboardWidget} widget
 */
function getWidget({ id, subType, type, dimensionIds, defaultOptions = {}, columns, adAccounts }) {
  const widget = {
    id,
    type,
  };

  switch (type) {
    case WIDGET_TYPE.alarms:
      break;

    case WIDGET_TYPE.graph: {
      widget.subType = subType;
      widget.selectedMetric = 'clicks';
      widget.selectedxAxis = 'cpc';
      widget.selectedGraphType = subType || 'bar';
      widget.dimensionIds = ['channel'];
      widget.comboChart = {
        yAxis1: { metric: 'spend', type: 'bar' },
        yAxis2: { metric: '', type: 'bar' },
        yAxis3: { metric: '', type: 'line' },
      };
      Object.keys(defaultOptions).forEach(k => {
        widget[k] = defaultOptions[k];
      });
      break;
    }

    case WIDGET_TYPE.graphBoxes: {
      const metrics = columns || getDefaultColumns(type);
      widget.filterTagList = [];
      widget.childWidgets = metrics.map(metric => ({
        // adAccounts: [],
        // filterTagList: [],
        alias: '',
        id: uuidv4(),
        metric,
        type: 'overviewChild',
      }));
      break;
    }

    case WIDGET_TYPE.pivotTable: {
      widget.page = { rowNum: 5 };
      if (subType === 'analytic' || subType === 'abTesting') {
        widget.subType = subType;
        widget.dimensionIds = dimensionIds || [];
        widget.columns = columns || [];
        widget.adAccounts = adAccounts || [];
      } else {
        widget.dimensionIds = dimensionIds || DEFAULT_DIMENSIONS;
        widget.columns = getDefaultColumns(subType || 'campaign');
        widget.filterTagList = [];

        if (adAccounts) {
          widget.adAccounts = adAccounts;
        }
      }

      Object.keys(defaultOptions).forEach(k => {
        widget[k] = defaultOptions[k];
      });
      break;
    }

    case WIDGET_TYPE.table: {
      widget.subType = subType;
      widget.columns = getDefaultColumns(subType);
      break;
    }

    case WIDGET_TYPE.creative: {
      const hasAdAccounts = adAccounts?.length > 0;
      const _adAccounts = hasAdAccounts ? adAccounts : [];
      const sortName = 'ctr';
      const columns = ['status', 'spend', 'impressions', 'clicks', 'cpm', 'cpc', 'ctr'];

      if (_adAccounts.length) {
        widget.adAccounts = _adAccounts;
      }

      widget.columns = columns;
      widget.filterTagList = [];
      widget.dimensionIds = ['ad'];
      widget.sort = { name: sortName, isDesc: false };
      break;
    }

    case WIDGET_TYPE.singleMetric: {
      // widget.adAccounts = [];
      widget.alias = '';
      widget.filterTagList = [];
      widget.metric = columns;
      widget.type = type;
      break;
    }

    case WIDGET_TYPE.smallTable: {
      // widget.adAccounts = [];
      widget.alias = '';
      widget.filterTagList = [];
      widget.dimensionIds = dimensionIds || [];
      widget.columns = columns || [];
      widget.sort = {
        isDesc: true,
        name: 'metric',
      };

      if (adAccounts) {
        widget.adAccounts = adAccounts;
      }
      break;
    }

    case WIDGET_TYPE.notepad: {
      if (subType) {
        widget.subType = subType;
      }

      break;
    }
    case WIDGET_TYPE.dummnyWidget:
      break;

    case WIDGET_TYPE.goal:
      {
        const metrics = columns || [];

        widget.mode = 'normal';
        widget.filterTagList = [];
        widget.childWidgets = metrics.map(metric => ({
          // adAccounts: [],
          // filterTagList: [],
          // shape: 'A',
          id: uuidv4(),
          type: 'goalChild',
          alias: '',
          metric,
          goalInfo: {
            value: '',
            metric: undefined,
            type: 0, // 0: value | 1: metric
          },
          order: 0,
          barType: 'line',
        }));
      }
      break;

    case WIDGET_TYPE.filter: {
      if (subType) {
        widget.subType = subType;
      }
      break;
    }
    default:
      break;
  }

  return widget;
}

function makeTableHeaderSticky({ containerEl, headerEl, tableEl }) {
  headerEl.style.position = 'sticky';
  headerEl.style.transition = 'top .05s ease-out';
  let intervalHandle = null;
  containerEl.onscroll = async function () {
    // for(let repetition=0; repetition<10; repetition++){
    let counter = 0;
    if (intervalHandle) window.clearInterval(intervalHandle);
    function adjustHeaderTop() {
      let headerTop = headerEl.getBoundingClientRect().top;
      let containerTop = containerEl.getBoundingClientRect().top;
      let tableElTop = tableEl.getBoundingClientRect().top;
      headerEl.style.top = Math.max(0, Math.round(containerTop - tableElTop)) + 'px';
      counter++;
      if (counter >= 20) window.clearInterval(intervalHandle);
    }
    adjustHeaderTop();
    intervalHandle = window.setInterval(adjustHeaderTop, 50);
  };
}
// containerEl = document.querySelector(".iefG.lfPQug.epxiBD")
// headerEl = document.querySelector(".cToyrr")
// tableEl = document.querySelector(".fDjVcm")
// stickyTableHeader({containerEl, headerEl, tableEl})

module.exports = {
  getWidget,
  makeTableHeaderSticky,
};
